export const userConfig = {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
    otpId: null,
    loginTempToken: null,
    userPhoneNumber: null,
    userInfo: null,
    selectedProject:null,
    selectedItem: null,
    ckeckCartRoute: null,
    checkProfileRoute: null,
  },
  mutations: {
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setRefreshToken(state, payload) {
      state.refreshToken = payload;
    },
    setOtpId(state, payload) {
      state.otpId = payload;
    },
    setLoginTempToken(state, payload) {
      state.loginTempToken = payload;
    },
    setUserPhoneNumber(state, payload) {
      state.userPhoneNumber = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setProjectInfo(state, payload) {
      state.selectedProject = payload;
    },
    setCartRoute(state, payload) {
      state.ckeckCartRoute = payload;
    },
    setProfileRoute(state, payload) {
      state.checkProfileRoute = payload;
    },
    setSelectedItem(state, payload) {
      state.selectedItem = payload;
    },
    clearCartRoute(state) {
      state.ckeckCartRoute = null;
    },
    clearProfileRoute(state) {
      state.checkProfileRoute = null;
    },

    clearAllConfigs(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.userPhoneNumber = null;
      state.loginTempToken = null;
      state.otpId = null;
      state.selectedProject = null
    },
    clearLoginToken(state) {
      state.loginTempToken = null;
      state.otpId = null;
    }
  },
};
